import { render, staticRenderFns } from "./ComponentActivity.vue?vue&type=template&id=07541366"
import script from "./ComponentActivity.vue?vue&type=script&lang=js"
export * from "./ComponentActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports